import React from "react";
import Button from "../../../../../../../../../../../components/ripple/Button";
import styles from './NetworkEditor.module.scss'

const RESTART_POLICIES = ['always', 'no', 'unless-stopped', 'on-failure',]

export default function RestartPolicy({app, update}) {

    const renderRestartList = () => {
        return RESTART_POLICIES.map((rp, i) => {
            return (
                <Button
                    className={styles.list__button}
                    displayType={app.restart === rp ? 'contained' : 'outlined'}
                    title={rp}
                    onClick={() => update({restart: rp})}
                    // icon='fas fa-plus'
                    visuals={{
                        colorBasic: ['var(--colorAccentLight)'],
                        colorFont: ['var(--colorBackgroundContent)'],
                        colorRippleTint: ['var(--colorAccentContrast)'],
                        borderRadius: '1.6rem',
                        height: '3.2rem',
                    }}
                    key={i}
                />
            )
        })

    }

    return (
        <div className={styles.list}>{renderRestartList()}</div>
    )
}